import React from 'react';
interface PriceDisplayProps {
  amount: number;
  originalAmount?: number;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}
export function PriceDisplay({
  amount,
  originalAmount,
  size = 'md',
  className = ''
}: PriceDisplayProps) {
  const currencySymbol = '$';
  const formatPrice = (val: number) => {
    return val.toLocaleString('es-AR');
  };
  const sizeClasses = {
    sm: 'text-2xl',
    md: 'text-4xl',
    lg: 'text-[64px]',
    xl: 'text-[88px]'
  };
  return <div className={`flex items-center gap-4 ${className}`} data-id="element-101">
      {originalAmount && <span className="text-[22px] line-through text-muted" data-id="element-102">
          {currencySymbol}
          {formatPrice(originalAmount)}
        </span>}
      <span className={`font-bebas leading-none text-gold ${sizeClasses[size]}`} data-id="element-103">
        {size === 'xl' || size === 'lg' ? <>
            <small className="align-super text-[32px]" data-id="element-104">{currencySymbol}</small>
            {formatPrice(amount)}
          </> : `${currencySymbol}${formatPrice(amount)}`}
      </span>
    </div>;
}